import React from 'react';
import Sidenavigation from '../layout/Sidenavigation';
import Topnavigation from '../layout/Topnavigation';
import Content from '../../CommonFolders/Unclosed-Tickets-List/Content';
import { Helmet } from "react-helmet";

export default function HelpdeskVUnclosedTicketsList() {

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ">
            {/* title */}
            <Helmet>
                <title>Unclosed Tickets</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end */}

            <main className="body-content">

                {/* Topnavigation start */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content Page='HelpdeskV' />
                {/* page content end  */}

            </main>

        </div>
    );
};